import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import bgImage from '../../Media/DMS.png';
import SanjayDhir from '../../Media/SanjayDhirNoBGGG.png';

export default function HeroSection() {
  useEffect(() => {
    AOS.init({ once: false });
    AOS.refresh();
  }, []);

  return (
    <div 
      className="container-fluid min-vh-100 h-75 d-flex align-items-center justify-content-center text-light"
      style={{
        backgroundImage: `linear-gradient(rgba(10, 15, 29, 0.85), rgba(2, 6, 23, 0.95)), url(${bgImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: "0 10px 25px -5px rgba(255, 255, 255, 0.2)",
      }}
    >
      <div className="container-fluid pt-5">
        <div className="row px-4 pt-4 align-items-center">
          
          {/* Left Photo Column */}
          <div 
            className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4 text-center pe-md-4 mb-4 mb-md-0" 
            data-aos="fade-right" 
            data-aos-duration="800"
          >
            <img 
              src={SanjayDhir} 
              className="img-fluid rounded w-100 drop-shadow-2xl img-hover-pop" 
              alt="Prof. Sanjay Dhir" 
            />
          </div>

          {/* Right Bio Column */}
          <div 
            className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-8 px-4 py-2" 
            data-aos="fade-left" 
            data-aos-duration="800"
          >
            <h1 className="avant-garde-text text-light">
              Prof. <br /> Sanjay Dhir
            </h1>
            <p className="text-light fs-5 fw-medium" style={{ textShadow: '1px 1px 2px black' }}>
              Fellow, IIM Lucknow and Professor, DMS, IIT Delhi
            </p>
            <br />
            
            <p className="text-light fs-6" style={{ textShadow: '1px 1px 2px black' }}>
              Prof. Sanjay Dhir is a <strong>Professor and Area Chair of Strategic Management</strong> in the Department of Management Studies, Indian Institute of Technology Delhi, New Delhi, India. He is a Fellow (Ph.D.) from the Indian Institute of Management (IIM) Lucknow.
            </p>
            <p className="text-light fs-6" style={{ textShadow: '1px 1px 2px black' }}>
              He received the ‘Teaching Excellence Award’ at IIT Delhi in 2019-20 for his course on Strategic Management at DMS, IIT Delhi. He has also been awarded the “InsideIIM Professor of the Year Award” for two years in a row in 2020 &amp; 2021.
            </p>
            <p className="text-light fs-6" style={{ textShadow: '1px 1px 2px black' }}>
              He has been nominated as an expert for the <strong>‘GNCTD state level committee on the oxygen infrastructure during COVID-19 pandemic’</strong> by the Delhi Government. He has also represented IITD and submitted the research titled “<em>IITD Review and Recommendations for Management of Oxygen during Covid-19 Crisis for GNCTD”</em> to the Hon’ble High Court (HC) in 2021 during the second wave of COVID-19.
            </p>

            {/* Bootstrap Action Buttons */}
            <div className="d-flex flex-wrap gap-3 pt-3">
              <NavLink to="/AboutMe" className="btn btn-outline-warning px-4 py-2 btn-hover-pop">
                Explore Profile
              </NavLink>
              <NavLink to="/Research/Books" className="btn btn-outline-warning px-4 py-2 btn-hover-pop">
                View Publications
              </NavLink>
              <a 
                href="https://scholar.google.co.in/citations?user=1ntflp8AAAAJ&hl=en" 
                target="_blank" 
                rel="noreferrer" 
                className="btn btn-outline-warning px-4 py-2 btn-hover-pop"
              >
                <i className="bi bi-globe2 me-1"></i> Google Scholar
              </a>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}